import SegmentedControl from "@components/core/SegmentedControl";
import sizeReferenceDisplay from "@utils/constants/sizeReferenceDisplay";

function SizeReferenceToggle({
  sizeReference,
  name,
  variant = "white",
  title,
  onChange = () => {},
}) {
  return (
    <div>
      {title && <p className="mb-3 font-weight-normal">{title}</p>}
      <SegmentedControl
        name={name}
        variant={variant}
        options={[
          { value: sizeReferenceDisplay.FR, label: "FR" },
          { value: sizeReferenceDisplay.IT, label: "IT" },
        ]}
        selectedValue={sizeReference}
        onChange={onChange}
      />
    </div>
  );
}

export default SizeReferenceToggle;
